module.exports = __webpack_public_path__ + "img/planning.9aa471d8.png";